// extracted by mini-css-extract-plugin
export var statItem = "_mg-1";
export var statsRow = "_mg-0";